import { Zone } from '../models';

export class ZoneHelper {

  static getZoneName(zoneId: string, zones: Zone[]): string {
    const zone = zones.find((z: Zone) => z.zoneId === zoneId);
    return zone?.zoneName || 'Unknown';
  }

  static getZoneTimezone(zoneId: string, zones: Zone[]): string {
    const zone = zones.find((z: Zone) => z.zoneId === zoneId);
    return zone?.timeZone || 'America/Santiago';
  }
}
